import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { useField, useFormikContext } from 'formik';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactPhoneInput from 'react-phone-number-input/input';

import {
  titleColor,
  buttonBackground,
  titleBackground,
} from '../styles/colors';

export const TitleContainer = styled.div`
  height: 100px;
  border-radius: 16px;
  background-color: ${titleBackground};
  display: flex;
  margin-bottom: 80px;

  @media (max-width: 600px) {
    height: 60px;
  }
`;

export const Title = styled.div`
  color: ${buttonBackground};
  font-size: 2rem;
  font-weight: 700;
  align-self: center;
  margin-left: 32px;

  @media (max-width: 600px) {
    font-size: 1.3rem;
  }
`;

export const TableContainer = styled.div`
  display: block;
  filter: drop-shadow(0px 4px 50px rgba(0, 36, 64, 0.12));
`;

export const TableTitleContainer = styled.div`
  height: 64px;
  background-color: ${buttonBackground};
  display: flex;
  border-radius: 8px 8px 0px 0px;
`;

export const TableTitle = styled.div`
  color: white;
  font-size: 1.4rem;
  font-weight: 600;
  align-self: center;
  margin-left: 48px;
`;

export const TableTitleNew = styled(Link)`
  margin-left: auto;
  margin-right: 16px;
  align-self: center;
`;

export const TableTitleIcon = styled(FontAwesomeIcon)`
  font-size: 2rem;
  font-weight: 500;
  color: white;
`;

export const Table = styled.table`
  background-color: white;
  width: 100%;
  border-collapse: collapse;

  @media (max-width: 1000px) {
    .mobileCollapse & {
      display: none;
    }
  }
`;

export const Row = styled.tr`
`;

export const HeaderCell = styled.th`
  color: ${buttonBackground};
  border-right: 2px solid ${buttonBackground};
  border-top: 2px solid ${buttonBackground};
  height: 54px;
  text-align: center;
`;

export const Cell = styled.td`
  font-size: 0.8rem;
  font-weight: 600;
  border-right: 2px solid ${buttonBackground};
  border-top: 2px solid ${buttonBackground};
  height: 54px;
  text-align: center;
`;

export const Label = styled.label`
  display: block;
  color: ${titleColor};
  font-weight: 500;
  margin-top: 12px;
`;

export const Button = styled.button`
  background-color: ${buttonBackground};
  color: white;
  border: 0px;
  border-radius: 4px;
  height: 37px;
  font-size: 0.9rem;
  font-weight: 500;
  width: 100%;
  margin-top: 16px;
`;

export const CancelButton = styled(Button)`
  background-color: white;
  color: ${buttonBackground};
  margin-top: 16px;
  border: 1px solid ${buttonBackground};
`;

const inputStyles = `
  display: block;
  width: 100%;
  padding: 0px;
  border: 1px solid #cccccc;
  border-radius: 4px;
  margin-top: 10px;
  padding-left: 30px;
  padding-top: 10px;
  padding-bottom: 10px;
  font-size: 1rem;

  .gray-input & {
    background-color: #EFEFEF;
    border: none;
  }
`;

const StyledInput = styled.input`
  ${inputStyles}
`;

const StyledPhoneInput = styled(ReactPhoneInput)`
  ${inputStyles}
`;

export const StyledSelect = styled.select`
  ${inputStyles}
`;

export const ErrorMessage = styled.div`
  color: red;
  border: 2px solid red;
  padding: 4px;
  margin-bottom: 6px;
`;

export const FormBody = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 32px;
`;

export const FormField = styled.div`
  width: 100%;

  @media (min-width: 700px) {
    max-width: calc(50% - 16px);
  }
`;

export const FormSpacer = styled.div`
  width: 100%;
  height: 16px;
`

export const ActionButton = styled(Link)`
  color: black;
  background-color: #eeeeee;
  padding: 6px;
  margin: 6px;
  text-decoration: none;
  border-radius: 6px;
  white-space: nowrap;
`;

export const ActionIcon = styled(FontAwesomeIcon)`
  margin-right: 6px;
  font-weight: 500;
  color: ${buttonBackground};
`;

const FieldError = styled.div`
  color: red;
`;

export const Input = props => {
  const [field, meta] = useField(props);

  return (
    <>
      <StyledInput
        {...field}
        {...props}
      />
      {meta.touched && meta.error && (
        <FieldError>{meta.error}</FieldError>
      )}
    </>
  );
};

const standardizedPhone = value => {
  if (value) {
    return '+1' + value.replace(/[-()/\s+/]/g, '');
  }

  return null;
};

export const PhoneInput = props => {
  const [field, meta] = useField(props);
  const { setFieldValue } = useFormikContext();

  return (
    <>
      <StyledPhoneInput
        country="US"
        {...field}
        {...props}
        onChange={value => setFieldValue(field.name, standardizedPhone(value))}
      />
      {meta.touched && meta.error && (
        <FieldError>{meta.error}</FieldError>
      )}
    </>
  );
};

export const Select = props => {
  const [field, meta] = useField(props);

  return (
    <>
      <StyledSelect
        {...field}
        {...props}
      />
      {meta.touched && meta.error && (
        <FieldError>{meta.error}</FieldError>
      )}
    </>
  );
};
